import React, { useContext, useState } from "react";
import { ChevronLeft } from "lucide-react";
import { WorkoutContext } from "../contexts/WorkoutContext";
import WeeklyTrainingCard from "../components/profile/WeeklyTrainingCard";
import { Vo2maxSheet } from "../components/profile/CardioSheets";
import useProgress from "../components/progress/useProgress";
import Vo2maxCard from "../components/progress/Vo2maxCard";
import PowerCurveCard from "../components/progress/PowerCurveCard";
import FtpCard from "../components/progress/FtpCard";
import TrendsCard from "../components/progress/TrendsCard";
import { heartRateBasis } from "../utils/heartRateZones";
import { machinesWithPower } from "../utils/progress";

/**
 * Progress (#203): the training analysis, out of Activity so Activity stays a
 * quick look at your week. Reached from Activity's Progress card. Each card
 * hides until there's something for it, so a new user sees training load and
 * a line on what unlocks the rest.
 */
const ProgressView = () => {
  const { setView } = useContext(WorkoutContext);
  const { loads, fitness, rows, loading, vo2max, userProfile, isAuthenticated } = useProgress();
  const [vo2Open, setVo2Open] = useState(false);
  const hrBasis = heartRateBasis(userProfile);
  const hasPower = machinesWithPower(rows).length > 0;

  return (
    <div className="mx-auto grid max-w-xl gap-3 px-4 pb-24 pt-3">
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => setView("activity")}
          aria-label="Back to Activity"
          className="-ml-2 flex h-10 w-10 items-center justify-center rounded-full text-muted-foreground hover:bg-accent"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <h2 className="text-[22px] font-bold text-white">Progress</h2>
      </div>

      <WeeklyTrainingCard weeks={loads} fitness={fitness} />
      <Vo2maxCard
        vo2max={vo2max}
        approximate={!!hrBasis?.maxEstimated && vo2max.fromHeartRate}
        onOpen={() => setVo2Open(true)}
      />
      <PowerCurveCard rows={rows} />
      <FtpCard rows={rows} weightKg={Number(userProfile?.bodyWeightKg) || null} />
      <TrendsCard rows={rows} />

      {!loading && !hasPower && (
        <p className="px-1 text-xs text-muted-foreground">
          {isAuthenticated
            ? "Ride or row with a machine that shows power, paired in Settings, to add your power curve, FTP and efficiency here."
            : "Sign in to keep your sessions and see your power curve, FTP and trends here."}
        </p>
      )}

      <Vo2maxSheet
        open={vo2Open}
        onClose={() => setVo2Open(false)}
        {...vo2max.sheet}
        onSetSex={() => setView("profile")}
        signedIn={isAuthenticated}
        onAddBenchmark={() => setView("profile")}
        hasWeight={!!userProfile?.bodyWeightKg}
        maxEstimated={!!hrBasis?.maxEstimated}
      />
    </div>
  );
};

export default ProgressView;
